import {
  DESIGNER_WORKFLOWS,
  DesignerWorkflow,
} from '@packages/systems/designer/workflows';

/**
 * Workflows that are not compatible with Component Canvas.
 * These workflows will be blocked/reset when entering component canvas.
 */
const COMPONENT_CANVAS_INCOMPATIBLE_WORKFLOWS = new Set<DesignerWorkflow>([
  DESIGNER_WORKFLOWS.COMMENT,
  DESIGNER_WORKFLOWS.ANALYZE_VISUAL_VIEW,
]);

/**
 * Returns true if the given workflow is incompatible with Component Canvas.
 */
export const isWorkflowIncompatibleWithComponentCanvas = (
  workflow: DesignerWorkflow | string | null | undefined
): boolean =>
  COMPONENT_CANVAS_INCOMPATIBLE_WORKFLOWS.has(workflow as DesignerWorkflow);
